﻿import Survey from "./Survey.svelte";

const confirmationPages = [
	{
		pageIndex: 0,
		component: Survey,
		routeId: "/Survey",
		showInConfirmation: true,
		confirmationHeading: null
	},
];

export default confirmationPages;
